import { IconButton } from '@wix/design-system';
import { ChatSmall } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Page, useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { useUnreadMessageCounter } from '../../../common/hooks/useUnreadMessageCounter';
import {
  selectChatbotDataLoading,
  selectIsUserEngaged,
  selectUnreadCount,
} from '../../../common/selectors/chat';
import { appRoutes } from '../../../react-router';
import { biHelpCenter, ButtonClicked } from '../../../util/bi';
import { headerActionsDataHooks } from './HeaderActions.dataHooks';
import { MessageNotificationCounter } from './MessageNotificationCounter';
import s from './styles.scss';

export const MessageNotification: FC = () => {
  const navigate = useNavigate();
  const chatbotDataLoading = useSelector(selectChatbotDataLoading);
  const unreadCount = useSelector(selectUnreadCount);
  const isUserEngaged = useSelector(selectIsUserEngaged);
  const currentPage = useCurrentPage();

  useUnreadMessageCounter(currentPage === Page.Chatbot);

  const shouldShowButton = currentPage !== Page.Chatbot && isUserEngaged;

  const openChatbot = useCallback(() => {
    navigate(appRoutes.chatbot());
    biHelpCenter.logHomepageHeaderButtonClicked(
      ButtonClicked.Notifications,
      unreadCount.toString(),
    );
  }, [navigate, unreadCount]);

  return shouldShowButton ? (
    <span className={s.messageNotification}>
      <IconButton
        skin="light"
        priority="secondary"
        size="small"
        onClick={openChatbot}
        dataHook={headerActionsDataHooks.newMessageNotificationIcon()}
      >
        <ChatSmall />
      </IconButton>
      {!chatbotDataLoading && <MessageNotificationCounter />}
    </span>
  ) : null;
};
